module.exports = __webpack_public_path__ + "img/icon-bear.10fc0817.svg";